import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"line-height":"40px"},
  class: "centered fs14 yu fw600 posRe"
}
const _hoisted_2 = {
  class: "fs20 fw600",
  style: {"border-bottom":"3px solid #ddd"}
}
const _hoisted_3 = {
  key: 0,
  class: "posAb",
  style: {"right":"0","top":"0px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "dgrey"
}
const _hoisted_7 = {
  key: 2,
  style: {"margin-left":"25px"}
}
const _hoisted_8 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_9 = { class: "fs12" }
const _hoisted_10 = { class: "fs24 pink" }
const _hoisted_11 = {
  key: 1,
  style: {"display":"inline-block"}
}
const _hoisted_12 = { class: "fs24" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "円/ID（税別）", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "fs14" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 3,
  class: "fs14"
}
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { key: 5 }
const _hoisted_22 = {
  key: 6,
  class: /*#__PURE__*/_normalizeClass(`w100 centered rad8 circle_button fs14 fw600 skyblueBg whiteColor`),
  style: {"padding":"4px 12px"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "選択中", -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`fl rad8 circle_button blueAround fs20 pad10 ${_ctx.plan.is_current ? `selected` : ``}`),
    style: `width:30%;min-width:270px;max-width:300px;`
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.plan.name), 1),
      (_ctx.plan.applied_coupon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/coupon_pink_2.png`),
              width: "40",
              height: "40"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      (_ctx.plan.amount == 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "無料"))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
            (_ctx.plan.applied_coupon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("s", null, _toDisplayString((_ctx.plan.amount / _ctx.plan.id_num).toLocaleString()), 1),
                    _createTextVNode(" → ")
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString((
                            _ctx.plan.cost_estimate_next_period.total_without_tax / _ctx.plan.cost_estimate_next_period.quantity
                        ).toLocaleString()), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString((_ctx.plan.amount / _ctx.plan.id_num).toLocaleString()), 1)
                ])),
            _hoisted_13
          ])),
      _hoisted_14,
      _createElementVNode("span", _hoisted_15, "アポ確定上限: " + _toDisplayString(_ctx.plan.max_appointment == -1 ? `無制限` : `${_ctx.plan.max_appointment}件まで`), 1),
      _hoisted_16,
      (_ctx.plan.amount == 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "ID制限: 5IDまで"))
        : (_openBlock(), _createElementBlock("span", _hoisted_18, "購入ID単位: " + _toDisplayString(_ctx.plan.id_num) + "単位", 1)),
      _hoisted_19,
      _hoisted_20,
      (_ctx.willStop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21))
        : (_ctx.plan.is_current)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
          : (_openBlock(), _createElementBlock("div", {
              key: 7,
              class: _normalizeClass(`w100 centered rad8 circle_button fs14 fw600 grey`),
              style: {"padding":"4px 12px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmChangePlan(_ctx.plan)))
            }, " 変更する "))
    ])
  ], 2))
}